// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"PlaceholderText_placeholder__2lZxy"};